const ga_config = {
  tracking_id: 'UA-140322712-1',
  domain: '.trouble.management',
  path: '/'
};

export default ga_config;
